import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, KImageURL, DefaultImage, UpdateShoppingCart, SaveOrderIntoTempTable } from "../GlobalScript";
import { ShoppingCartContext } from '../dealer/ShoppingCartContext';
import { CatalogContext } from '../dealer/CatalogContext';
import $ from 'jquery';
import Cookies from 'js-cookie';
import Select from 'react-select';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer';
import { useTranslation } from 'react-i18next';

export default function Catalog() {

    const navigate = useNavigate();
    const location = useLocation();
    const [vehicle, setVehicle] = useState('');
    const [model, setModel] = useState('');
    const [year, setYear] = useState('');
    const [committedVehicle, setCommittedVehicle] = useState('');
    const [committedYear, setCommittedYear] = useState('');
    const [committedModel, setCommittedModel] = useState('');
    const [searchVehicle, setSearchVehicle] = useState('');
    const [searchModel, setSearchModel] = useState('');
    const [searchYear, setSearchYear] = useState('');
    const [category, setCategory] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(new Set());
    const [catalogItems, setCatalogItems] = useState([]);
    const [ModelList, setModelList] = useState(null);
    const [YearList, setYearList] = useState(null);
    const [VehicleList, setVehicleList] = useState(null);
    const [pop, setPop] = useState(false);
    const [FirstLoad, setFirstLoad] = useState(false);
    const [ChangeVehicle, setChangeVehicle] = useState(false);
    const [level1, setLevel1] = useState(null);
    const [level2, setLevel2] = useState(null);
    const [popUpModal, setPopUpModal] = useState(false);
    const [tempItem, setTempItem] = useState({});
    const [itemSizes, setItemSizes] = useState(new Map());
    const [qtys, setQtys] = useState({});    
    const [keywords, setKeywords] = useState(null);
    const [level1Name, setLevel1Name] = useState(null);
    const [level2Name, setLevel2Name] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [dataReady, setDataReady] = useState(false);
    const [loading, setLoading] = useState(true);
    const [categoryMap, setCategoryMap] = useState(new Map());
    const { shoppingCart, setShoppingCart, setCategoriesOpen, setDropdownOpen } = useContext(ShoppingCartContext);
    const { searchRequest, setSearchRequest, scrollY, setScrollY, savedSearchRequest, setSavedSearchRequest } = useContext(CatalogContext);
    const { t } = useTranslation();
    const [sortByText, setSortByText] = useState(t('catalog.sortBy'));
    const [errorMessage, setErrorMessage] = useState('');
    const [isDealer, setIsDealer] = useState(true);
    const [UserInfo, setUserInfo] = useState(null);

    useEffect(() => {
        if (window.location.origin.indexOf("kdealer") > -1 || window.location.origin.indexOf("k-dealer") > -1) {
            document.title = 'K-Dealer - Catalog';
        } else if (window.location.origin.indexOf("kcountries") > -1 || window.location.origin.indexOf("k-countries") > -1) {
            document.title = 'K-Countries - Catalog';
        } else if (window.location.origin.indexOf("localhost") > -1) {
            document.title = 'K-Dealer - Catalog';
        }
    }, []);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const handlePopUpModalShow = () => {
        setPopUpModal(true);
    }
    const handlePopUpModalClose = () => {
        setPopUpModal(false);
        setTempItem(null);
        if (errorMessage) {
            setErrorMessage('');
        }
    }

    useEffect(() => {
        if (!location.state || !location.state.vehicle || location.state.vehicle.length === 0
            || !location.state.model || location.state.model.length === 0
            || !location.state.year || location.state.year.length === 0) {
            if (!location.state.level1 && !location.state.keywords) {
                navigate('/dealerhome');
                return;
            }
            setVehicle('')
            setSearchVehicle('');
            setModel('');
            setSearchModel('');
            setYear('');
            setSearchYear('');

            if (location.state.category) {
                setSelectedCategories(
                    new Set(location.state.category)
                );
            } else if (location.state.level3) {
                const set = new Set();
                set.add(location.state.level3);

                setSelectedCategories(set);
            } else {
                setSelectedCategories(new Set());
            }

            if (location.state.level1) {
                setKeywords(null);
                setLevel1(location.state.level1);
                setLevel2(location.state.level2);
                setLevel1Name(location.state.level1Name);
                setLevel2Name(location.state.level2Name);
            } else {
                setLevel1(null);
                setLevel2(null);
                setLevel1Name(null);
                setLevel2Name(null);
                setKeywords(location.state.keywords);
            }
           
        } else {
            setVehicle(location.state.vehicle)
            setSearchVehicle(location.state.vehicle);
            setLevel1(null);
            setLevel2(null);
        }
        setFirstLoad(true);
        const cart = GetShoppingCart(shoppingCart);
        setShoppingCart(cart);
    }, [location])

    //useEffect(() => {
    //    CheckSession();
    //    if (!UserInfo) {
    //        let ck = GetCoockie();
    //        setUserInfo(ck);
    //        window.GlobalLoading++;
    //    }
    //    if (window.GlobalLoading === 1) {
    //        window.location.reload();
    //    }
    //}, [UserInfo])

    useEffect(() => {
        if (!VehicleList) {
            LoadVehicleList();
        }
    }, [VehicleList]);

    useEffect(() => {
        if (vehicle) {
            LoadYearList();
            if (FirstLoad) {
                setYear(location.state.year);
                setModel(location.state.model);
                setSearchYear(location.state.year);
                setSearchModel(location.state.model);
            }
        }
        if (!vehicle || FirstLoad === false) {
            setYear('');
            setModel('');
            setYearList(null);
            setModelList(null);
        }
    }, [vehicle]);

    useEffect(() => {
        if (year) {
            LoadModelList();
            if (FirstLoad) {
                setModel(location.state.model);
                getCategoriesByVehicle();
                getCatalogItemsByVehicle();
                setFirstLoad(false);
            }
        }
        if (!year || FirstLoad === false) {
            setModel('');
            setModelList(null);
        }
    }, [year]);

    useEffect(() => {
        if (level1) {
            getCategoriesByLevel();
            getCatalogItemsByLevel();
        }
    }, [level1, level2]);

    //useEffect(() => {
    //    if (preSelectedCategory && catalogItems) {
    //        $('#cat' + preSelectedCategory).prop('checked', true);
    //    }
    //}, [catalogItems, preSelectedCategory]);

    useEffect(() => {
        const sameSearch = JSON.stringify(searchRequest) === JSON.stringify(savedSearchRequest);

        if (!catalogItems.length || scrollY === null || !sameSearch) {
            return;
        }

        const interval = setInterval(() => {
            const height = document.documentElement.scrollHeight;

            if (height >= scrollY) {
                window.scrollTo({
                    top: scrollY,
                    behavior: 'auto'
                });
                setScrollY(null);
                clearInterval(interval);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [catalogItems, scrollY]);

    useEffect(() => {
        const validPaths = [
            '/catalog',
            '/catalog/item'
        ];

        if (!validPaths.includes(location.pathname)) {
            setScrollY(null);
        }

    }, [location.pathname]);
    
    useEffect(() => {
        if (level1) {
            getCatalogItemsByLevel();
        }
        if (searchYear && searchVehicle && searchModel) {
            getCatalogItemsByVehicle();
        }
    }, [sortBy]);

    const LoadVehicleList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("catalog/GetVehicleList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setVehicleList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            if (!loading) {
                handleClosePop();
            }
        }
    }

    const LoadYearList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch('catalog/GetYearList/' + vehicle);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setYearList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            if (!loading) {
                handleClosePop();
            }
        }
    }

    const LoadModelList = async () => {
        try {
            if (!year || !vehicle ) {
                return;
            }
            handlePop();
            const data = [vehicle, year];
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('catalog/GetModelList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setModelList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            if (!loading) {
                handleClosePop();
            }
        }
    }

    useEffect(() => {
        if (VehicleList && ModelList && vehicle && model) {
            setDataReady(true);
        }
    }, [VehicleList, ModelList, vehicle, model]);

    const getCategoriesByVehicle = async () => {
        try {
            if (!searchYear || !searchVehicle || !searchModel) {
                return;
            }
            const data = {
                level1: searchVehicle,
                model: searchModel,
                year: searchYear,
                level2: '',
                keywords: ''
            };
            getCategories(data);
        } catch (e) {
            console.log(e);
        } finally {
            if (ChangeVehicle === true) {
                setCommittedModel(ModelList?.find(item => item.value === model)?.label);
                setCommittedVehicle(VehicleList?.find(item => item.value === vehicle)?.label);
            }
        }
    }

    const getCategories = async (data) => {
        if (!data) {
            return;
        }
        CheckSession();
        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch('catalog/GetCategoryList/', rqst);
        if (response.status !== 200) {
            return;
        }
        const lst = await response.json();
        setCategory(lst);
        const newMap = new Map(
            Object.entries(lst).map(([key, value]) => [value.value, value.label.substring(0, value.label.lastIndexOf("(")).trim()])
        );
        setCategoryMap(newMap);
    }

    const getCategoriesByLevel = async () => {
        try {
            if (!level1) {
                return;
            }
            const data = {
                level1: level1,
                level2: level2 ?? '',
                model: '',
                year:'',
                keywords: ''
            };
            getCategories(data);
        } catch (e) {
            console.log(e);
        } 
    }

    const getCategoriesByKeywords = async () => {
        try {
            if (!keywords) {
                return;
            }
            const data = {
                level1: '',
                level2: '',
                model: '',
                keywords: keywords,
                year:''
            };
            getCategories(data);
        } catch (e) {
            console.log(e);
        }
    }

    const getCatalogItemsByVehicle = async () => {
        try {
            if (!searchYear || !searchVehicle || !searchModel) {
                return;
            }
            const user = GetCoockie();
            const data = {
                level1: searchVehicle,
                level2: '',
                year: searchYear,
                model: searchModel,
                category: selectedCategories && selectedCategories.size > 0 ? [...selectedCategories] : null,
                sortBy: sortBy ?? 1,
                keywords: '',
                dealerID: user.dealerID,
            }
            getCatalogItems(data);
            setDataReady(true);
        } catch (e) {
            console.log(e);
        }
    }
    
    const getCatalogItems = async (data, forceRefresh = false) => {
        if (!data) {
            return;
        }

        if (!forceRefresh && catalogItems.length > 0 && JSON.stringify(data) === JSON.stringify(searchRequest)) {
            return;
        }

        setLoading(true);
        handlePop();
        CheckSession();
        setSearchRequest(data);

        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch('catalog/GetItemList/', rqst);
        if (response.status !== 200) {
            handleClosePop();
            return;
        }
        const lst = await response.json();
        setCatalogItems(lst);
        setLoading(false);
    }

    useEffect(() => {
        if (!loading) {
            handleClosePop();
        } else {
            handlePop();
        }
    }, [loading])

    const getCatalogItemsByKeywords = async () => {
        try {
            if (!keywords) {
                return;
            }
            setCommittedModel('');
            setCommittedVehicle('');
            setCommittedYear('');
            const user = GetCoockie();
            const data = {
                level1: '',
                level2: '',
                year: '',
                model: '',
                category: selectedCategories && selectedCategories.size > 0 ? [...selectedCategories] : null,
                sortBy: sortBy ?? 1,
                keywords: keywords,
                dealerID: user.dealerID,
            }
            getCatalogItems(data);
        } catch (e) {
            console.log(e);
        }
    }

    const getCatalogItemsByLevel = async () => {
        try {
            if (!level1) {
                return;
            }
            const user = GetCoockie();
            const data = {
                level1: level1,
                level2: level2??'',
                year: '',
                model: '',
                category: selectedCategories && selectedCategories.size > 0 ? [...selectedCategories] : null,
                sortBy: sortBy ?? 1,
                keywords: '',
                dealerID: user.dealerID,
            }
            getCatalogItems(data);
        } catch (e) {
            console.log(e);
        }
    }

    const GoToCatalog = async (level1, level2, level3, level1Name, level2Name, level3Name) => {
        try {
            if (!level1) {
                return;
            }

            setScrollY(null);
            navigate('/catalog', { state: { level1: level1, level2: level2, level3: level3, level1Name: level1Name, level2Name: level2Name, level3Name: level3Name, keywords: keywords } });
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (searchYear && searchVehicle && searchModel) {
            getCatalogItemsByVehicle();
        } else if (level1) {
            getCatalogItemsByLevel();
        } else if (keywords) {
            getCatalogItemsByKeywords();
        }
    }, [selectedCategories])

    useEffect(() => {
        getCatalogItemsByKeywords();
        getCategoriesByKeywords();
    }, [keywords])

    const handleChangeCategory = (e) => {
        const set = new Set(selectedCategories);
        if (e.target.checked) {
            set.add(e.target.value);
        } else if (set.has(e.target.value)) {
            set.delete(e.target.value);
        }
        setSelectedCategories(set);
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'vehicle') {
            setVehicle(value);
        } else if (name === 'model') {
            setModel(value);
        } else if (name === 'year') {
            setYear(value);
        }
    }

    const changeVehicle = () => {
        setDataReady(false);
        setLevel1(null);
        setLevel2(null);
        setLevel1Name(null);
        setLevel2Name(null);
        setSearchModel(model);
        setSearchVehicle(vehicle);
        setSearchYear(year);
        setSelectedCategories(new Set());
        setChangeVehicle(true);
        setKeywords(null);
        setCommittedYear(year);
    }

    useEffect(() => {
        if (ChangeVehicle === true && searchModel && searchVehicle && searchYear) {
            getCategoriesByVehicle();
            getCatalogItemsByVehicle();
            setChangeVehicle(false);
        }
    }, [ChangeVehicle, searchModel, searchVehicle, searchYear]);

    const clearCategory = () => {
        setSelectedCategories(new Set());
        $('input:checkbox[id^="cat"]').prop('checked', false);
    }

    const goItemPage = (item) => {
        setScrollY(window.scrollY);
        setSavedSearchRequest(searchRequest);
        navigate('/catalog/item', { state: { vehicle: vehicle, model: model, year: year, item: item, level1: level1, level2: level2, level3: null, level1Name: level1Name, level2Name: level2Name, level3Name: null, keywords: keywords, category: selectedCategories } })
    }

    const handleSortBy = (val) => {
        setSortBy(val);
        if (val === 1) {
            setSortByText(t('catalog.sortByCategory'));
        } else if (val === 2) {
            setSortByText(t('catalog.sortByPriceLowHigh'));
        } else if (val === 3) {
            setSortByText(t('catalog.sortByName'));
        } else if (val === 4) {
            setSortByText(t('catalog.sortByPriceHighLow'));
        }
    }

    const handleQtyChange = (e, key) => {
        const value = Number(e.target.value);

        if (value > 0) {
            setQtys((prev) => ({
                ...prev,
                [key]: value
            }));
        } else {
            setQtys((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });
        }
    }

    const checkIfIsApparel = async (item)=>{
        const addRes = await fetch('catalog/GetAdditionInfoFromDB/' + item.itemNumber);
        if (addRes.status !== 200) {
            return;
        }
        const addInfoRes = await addRes.json();
        return addInfoRes && addInfoRes.prodLinesText === "APPAREL";
    }

    const checkItem = (item) => {
        if (checkIfIsApparel(item)) {
            setTempItem(item);
            getItemSizes(item);
        } else {
            addToCart([item]);
        }
    }

    const addToCart = async (items) => {
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const cart = GetShoppingCart(shoppingCart);
            const crrMap = new Map();
            let orderType = cart?.orderType || "1";
            let dealerID = cart?.dealerID || user.dealerID;
            if (cart && cart.items) {
                for (const element of cart.items) {
                    const itmNum = element?.item?.distitemNbr?.replaceAll('-', '').replaceAll(' ', '') ?? '';
                    const id = itmNum + (!element.item.vin ? '' : ('|' + element.item.vin));
                    crrMap.set(id, element);
                }
            }
            for (const item of items) {
                const partNum = item.itemNumber.replaceAll('-', '').replaceAll(' ', '');
                const idPart = partNum + (!item.vin ? '' : ('|' + item.vin));
                console.log(partNum)
                const qty = item.qty ?? 1;

                if (cart?.items) {
                    for (const element of cart.items) {
                        const itmNum = element?.item?.distitemNbr?.replaceAll('-', '').replaceAll(' ', '') ?? '';
                        const id = itmNum + (!element.item.vin ? '' : ('|' + element.item.vin));
                        if (element.item.qtyOrdered > 0 && itmNum === partNum) {
                            const copy = { ...element };
                            copy.item.new = true;
                            copy.item.qtyOrdered = qty;
                            copy.item.qty = qty;
                            crrMap.set(id, copy);
                            break;
                        }
                    }
                }

                if (!crrMap.has(idPart)) {
                    const skuqty = {
                        label: user.dealerID,
                        value: partNum,
                    };
                    const rqst = {
                        method: 'POST',
                        headers: { 'Content-type': 'application/json' },
                        body: JSON.stringify(skuqty),
                    };
                    const res = await fetch('kdealer/GetSKUImage/', rqst);
                    if (res.status !== 200) throw new Error(res.statusText);
                    const img = await res.text();

                    const newItem = {
                        item: {
                            distitemNbr: partNum,
                            qty: qty,
                            qtyOrdered: qty,
                            prodOrdCnt: qty,
                            new: true,
                            itemStaCode: "1",
                            warehouseAvailColorR: "G0000002",
                            warehouseAvailColorD: "G0000002",
                            warehouseAvailColorL: "G0000002",
                            dealerPrice: 0,
                            retailPrice: 0,
                            whslePkgCnt: 1,
                            boCnt: 0,
                            factorAlert: false,
                            errorMsg: "",
                            inventoryType: "",
                            inventoryTypeIcon: "",
                            statusIcon: "",
                            hazMatCode: "N",
                            oversizeCode: "N",
                            substitutedSKU: "",
                            ltl: false,
                            pk: false,
                            memo: "",
                            vin:''
                        },
                        addInfo: {
                            itemNumber: partNum,
                            itemStaCode: "1",
                            itemStaIcon: "green-icon",
                            itemDesc: "",
                            img: img,
                            returnable: false,
                            exchangable: false
                        }
                    };
                    crrMap.set(idPart, newItem);
                }            
            }            
            const arr = Array.from(crrMap.values());
            const combinedCart = {
                alerts: cart ? cart.alerts : null,
                items: arr,
                orderName: cart ? cart.orderName : '',
                orderType: cart? cart.orderType: null,
                shipToDealerID: dealerID,
                kCode: (cart && cart.kCode) ?? '',
                fromVIPortal: (cart && cart.fromVIPortal) ?? false
            }
            SaveOrderIntoTempTable(combinedCart, 2);
            UpdateShoppingCart(combinedCart, setShoppingCart);
            setQtys({});
            setDropdownOpen(true);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
            if (tempItem) {
                handlePopUpModalClose();
            }
        }
    }

    const getItemSizes = async (item) => {
        if (!item) {
            return;
        }
        handlePop();
        CheckSession();
        const user = GetCoockie();
        const data = {
            label: user.dealerID,
            value: item.itemNumber
        };
        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch('catalog/GetItemSizes/', rqst);
        if (response.status !== 200) {
            handleClosePop();
            return;
        }
        const lst = await response.json();

        if (lst.length === 0) {
            handleClosePop();
            addToCart([item]);
            return;
        }

        const map = new Map();
        lst.forEach((element) => {
            if (isDealer !== element.isDealer) {
                setIsDealer(element.isDealer);
            }
            map.set(element.itemNumber, element);
        });
        setItemSizes(map);
        handleClosePop();
        handlePopUpModalShow();
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="mb-3">
                    <Col sm={12} className="">
                        <Card className="green-border-bottom">
                            <Card.Body>
                                <Row>
                                    <Col sm={2}>
                                        <Row>
                                            <Col sm={12} className="text-left">
                                                <h3 className="heading mt-2">{t('dealerhome.SHOP BY VEHICLE')}</h3>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col sm={6}>
                                        <Row className="border-right">
                                            <Col sm={3}>
                                                <Form.Select aria-label="Vehicle" value={vehicle} onChange={handleChange} name="vehicle" className="mt-2">
                                                    <option value={''}>{t('dealerhome.Select a vehicle')}</option>
                                                    {VehicleList && VehicleList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col sm={2}>
                                                <Form.Select aria-label="Year" value={year} onChange={handleChange} name="year" className="mt-2">
                                                    <option value={''}>{t('dealerhome.Year')}</option>
                                                    {YearList && YearList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Select aria-label="Model" value={model} onChange={handleChange} name="model" className="mt-2">
                                                    <option value={''}>{t('dealerhome.Select a Model')}</option>
                                                    {ModelList && ModelList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>

                                            <Col sm={3} className="text-center">
                                                <Button variant="primary" onClick={changeVehicle} disabled={!vehicle || !year || !model} className="btn-maintain">
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    {t('button.SHOP')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col sm={4}>
                                        <Row>
                                            <Col sm={8} className="text-left">
                                                <h3 className="heading mt-2">{t('dealerhome.SHOP BY CATEGORY')}</h3>
                                            </Col>

                                            <Col sm={4}>
                                                <Button variant="secondary" onClick={() => setCategoriesOpen(true)}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    {t('button.SHOP')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={3} className="catalog-categories">
                        <div className="sticky-top">
                            <Card className="summary-card mb-5">
                                <Card.Body>
                                    <Row className="title-group summary-title keep-layout checkout-title-row">
                                        <Col className="checkout-title black-border-bottom">
                                            <Card.Title className="heading" role="heading">{t("catalog.category")}</Card.Title>
                                        </Col>
                                        <Col className="black-border-bottom">
                                            {category && category.length > 0 && 
                                                <Card.Subtitle className="smaller-text underline right-text red" onClick={clearCategory}>{t("catalog.clearAll")}</Card.Subtitle>
                                            }
                                        </Col>
                                       
                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            {category.map(cat => (
                                                <Form.Check id={"cat" + cat.value} key={"cat" + cat.value}
                                                    type="checkbox"
                                                    label={cat.label}
                                                    value={cat.value}
                                                    onChange={handleChangeCategory}
                                                    checked={selectedCategories.has(cat.value)}
                                                    className="mt-2"
                                                />
                                            ))}
                                        </Col>
                                    </Row>
                                    
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>

                    <Col sm={9}>
                        <Row>
                            <Col sm={7}>
                                <p className="catalog-breadcrumbs">
                                    <span>
                                        {t("catalog.shopBy", {
                                            type: keywords
                                            ? t("catalog.shopByKeywords")
                                            : level1
                                            ? t("catalog.shopByCategory")
                                            : t("catalog.shopByVehicle")
                                        })}
                                        {/*Shop by {keywords ? 'Keywords' : (level1 ? 'Category' : 'Vehicle')}*/}
                                    </span>
                                    {(level1Name || (committedVehicle && dataReady)) &&
                                        <>
                                            {' > '}
                                            {level1Name &&
                                                <span onClick={() => GoToCatalog(level1, null, null, level1Name, null,null)}>{level1Name}</span>
                                            }
                                            {level2Name &&
                                                <>
                                                    {' > '}
                                                    <span>{level2Name}</span>
                                                </>
                                            }
                                            {committedVehicle && !level1 &&
                                                <>
                                                    <span className="no-hover">
                                                        {committedVehicle}
                                                    </span>
                                                    {committedModel &&
                                                        <>
                                                            { ' > '}
                                                            <span>{committedYear + ' ' + committedModel}</span>
                                                        </>                                                
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                    {keywords && <>
                                        {' > '}
                                        <span>{keywords}</span>
                                    </> }
                                </p>
                            </Col>

                            <Col sm={5} className="text-right">
                                {catalogItems.length > 0 &&
                                    <DropdownButton
                                        variant="outline-dark"
                                        title={sortByText}
                                        className="mb-2 dropdown-info"
                                    >
                                        <Dropdown.Item onClick={() => handleSortBy(1)}>{t("catalog.category")}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleSortBy(3)}>{t("catalog.name")}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleSortBy(2)}>{t("catalog.priceLowHigh")}</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleSortBy(4)}>{t("catalog.priceHighLow")}</Dropdown.Item>
                                   
                                    </DropdownButton>
                                }
                            </Col>
                        </Row>
                        <Row>
                            {catalogItems.length > 0 ? catalogItems.map((item, index) => (
                                <Col lg={4} md={6} key={item.id} className="catalog-item-col">
                                    <Card className="catalog-item-card">
                                        <Card.Body className="green-border-bottom-thin" onClick={() => goItemPage(item)}>
                                            <Row>
                                                <Col sm={12} className="text-center mb-4">
                                                    <img src={KImageURL(item.itemNumber, item.img)}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = DefaultImage;
                                                        }}
                                                        alt={item.descr} className="catalog-item-image"
                                                        loading="lazy"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-2">
                                                <Col sm={12}>
                                                    <h2 className="heading">{item.descr}</h2>
                                                    <p className="smaller-text">
                                                        <span>
                                                            #{item.itemNumber} |
                                                        </span>
                                                        {item.catgory &&
                                                            item.catgory.split(',').map((cat, indexCat) => (
                                                                <span key={indexCat} className="catalog-item-category">
                                                                    {cat.trim()}
                                                                </span>
                                                            ))
                                                        }
                                                    </p>
                                                </Col>

                                            </Row>

                                            <Row>
                                                <Col sm={8}>
                                                    {item.isDealer === false && <p className="bold mb-0">{t("catalog.distributorPrice")}</p> }
                                                    <p className={item.isDealer === false ? "smaller-text" : "bold mb-0"}>{t("catalog.dealerPrice")}</p>
                                                    <p className="smaller-text">{t("catalog.msrp")}</p>
                                                </Col>
                                                <Col sm={4}>
                                                    <h2 className="heading catalog-item-price">{item.price}</h2>
                                                    {item.isDealer === false && <p className="smaller-text">{item.priceForDistributorDisplay}</p>}
                                                    <p className="smaller-text">{item.retailPrice}</p>
                                                </Col>
                                            </Row>
                                        </Card.Body>

                                        <div className="catalog-item-button" onClick={() => checkItem(item)}>
                                            <h1 className="heading">{t("catalog.addToCart")}</h1>
                                        </div>
                                    </Card>
                                </Col>
                            ))
                            : !loading &&
                                <Col sm={12} className="text-center mt-5">
                                    <p>{t("catalog.noResults")}</p>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>

            </Container>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <Modal show={popUpModal} onHide={handlePopUpModalClose} dialogClassName="dealer-section" centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{t("catalog.selectSize")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                {tempItem &&
                    <>
                        <Modal.Body>
                            <Row>
                                <Col sm={3}>
                                    <img src={KImageURL(tempItem.itemNumber, tempItem.img)}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = DefaultImage;
                                        }}
                                        alt={tempItem.descr}
                                        className="catalog-item-image"
                                    />
                                </Col>

                                <Col sm={9}>
                                    <Row>
                                        <Col sm={12}>
                                            <h3 className="text-left heading">{tempItem.descr}</h3>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={1}>
                                            <p className="mt-3">{t("catalog.size")}</p>
                                        </Col>

                                        <Col sm={11}>
                                            <Row>
                                                {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                    <Col sm={2} key={key} className="flex-center">
                                                        <div className={qtys[key] ? "item-product-size active" : "item-product-size"}
                                                            data-value={key}
                                                        >
                                                            {value.size}
                                                        </div>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className="mt-2">
                                        <Col sm={1}>
                                            <p className="mt-2">{t("catalog.qty")}</p>
                                        </Col>

                                        <Col sm={11}>
                                            <Row>
                                                {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                    <Col sm={2} key={key} className="flex-center">
                                                        <Form.Control
                                                            type="number"
                                                            min="1"
                                                            step="1"
                                                            id={`qty-${key}`}
                                                            aria-describedby="Quantity"
                                                            className='form-control size-input'
                                                            onChange={(e) => handleQtyChange(e, key)}
                                                            value={qtys[key] ?? ''}
                                                        />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    </Row>

                                    {isDealer === false &&
                                        <Row className="mt-2">
                                            <Col sm={1}>
                                                <p className="mt-2">Dist. Price:</p>
                                            </Col>

                                            <Col sm={11}>
                                                <Row>
                                                    {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                        <Col sm={2} key={key} className="flex-center">
                                                            <h5 className="text-center mt-4 heading catalog-item-price">{value.price}</h5>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Col>
                                        </Row>
                                    }

                                    <Row className="mt-2">
                                        <Col sm={1}>
                                            <p className="mt-2">Dealer Price:</p>
                                        </Col>

                                        <Col sm={11}>
                                            <Row>
                                                {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                    <Col sm={2} key={key} className="flex-center">
                                                        {value.isDealer === false ?
                                                            <p className="text-center mt-4 catalog-item-price">{value.dealerPriceForDistributorDisplayOnly}</p>
                                                            :
                                                            <h5 className="text-center mt-4 heading catalog-item-price">{value.price}</h5>
                                                        }
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className="mt-2">
                                        <Col sm={1}>
                                            <p className="mt-2">MSRP:</p>
                                        </Col>

                                        <Col sm={11}>
                                            <Row>
                                                {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                    <Col sm={2} key={key} className="flex-center">
                                                        <p className="text-center mt-2">{value.retailPrice}</p>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Row>
                                <Col sm={12} className="text-center">
                                    {errorMessage && 
                                        <p className="red">{errorMessage}</p>
                                    }

                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            const itemsToAdd = Array.from(itemSizes.entries())
                                                .filter(([sku]) => qtys[sku] > 0)
                                                .map(([sku, item]) => ({
                                                    ...item,
                                                    itemNumber: sku,
                                                    qty: qtys[sku]
                                                }));

                                            if (itemsToAdd.length > 0) {
                                                addToCart(itemsToAdd);
                                            } else {
                                                setErrorMessage("Please select at least one size to add to cart.")
                                            }
                                        }}
                                    >
                                        {t("catalog.addToCart")}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </>        
                }
            </Modal>

            <FooterDealer />           
        </>
    );
}